import {Box} from "@mui/material";
import styled from "@mui/material/styles/styled";
import {NAVIGATION_WIDTH} from '../../components/admin/LeftNavigation.jsx'

export const AdminRoot = styled(Box)(({ theme }) => ({
    marginLeft: `calc(${NAVIGATION_WIDTH}px + 1rem)`,
}));